import React from 'react';
import { Link } from 'react-router-dom';
import { HERO } from '../../mock';
import { ArrowRight } from 'lucide-react';

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      {/* Smoky ambient layers */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[1100px] h-[700px] rounded-full bg-amber-300/[0.06] blur-3xl" />
        <div className="absolute top-40 left-10 w-[400px] h-[400px] rounded-full bg-amber-500/[0.05] blur-3xl" />
        <div className="absolute top-20 right-10 w-[500px] h-[500px] rounded-full bg-white/[0.03] blur-3xl" />
        <SmokeSVG />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 pt-28 md:pt-40 pb-24 md:pb-36 text-center">
        <p className="text-[11px] md:text-[12px] tracking-[0.25em] uppercase text-amber-300/80 mb-6">
          {HERO.kicker}
        </p>
        <h1 className="font-serif text-white text-[38px] leading-[1.05] md:text-[66px] md:leading-[1.05] tracking-tight">
          <span className="block bg-gradient-to-b from-white to-neutral-400 bg-clip-text text-transparent">
            {HERO.title_a}
          </span>
          <span className="block bg-gradient-to-b from-amber-100 to-amber-400 bg-clip-text text-transparent italic">
            {HERO.title_b}
          </span>
        </h1>
        <p className="mt-8 max-w-3xl mx-auto text-neutral-400 text-[15px] md:text-[17px] leading-relaxed">
          {HERO.subtitle}
        </p>

        <div className="mt-10 flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/apply"
            className="group inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-[15px] font-medium text-neutral-900 bg-gradient-to-b from-amber-200 to-amber-400 shadow-[0_8px_30px_-6px_rgba(251,191,36,0.55)] hover:shadow-[0_14px_40px_-6px_rgba(251,191,36,0.7)] hover:-translate-y-[2px] transition-all duration-200"
          >
            {HERO.cta}
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </Link>
          <a
            href="#book"
            className="inline-flex items-center gap-2 rounded-full px-6 py-3.5 text-[15px] text-neutral-200 border border-white/10 hover:border-amber-300/40 hover:text-white transition-colors"
          >
            Read the Book
          </a>
        </div>
      </div>
    </section>
  );
}

function SmokeSVG() {
  return (
    <svg
      className="absolute inset-0 w-full h-full opacity-[0.18]"
      viewBox="0 0 1440 800"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="sg1" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>
      </defs>
      <g filter="url(#b)">
        <path
          d="M150 520 C 320 380 520 620 720 460 C 920 300 1120 580 1300 420"
          stroke="url(#sg1)"
          strokeWidth="110"
          fill="none"
          strokeLinecap="round"
        />
        <path
          d="M120 640 C 320 520 540 700 760 560 C 980 420 1180 660 1340 540"
          stroke="url(#sg1)"
          strokeWidth="60"
          fill="none"
          strokeLinecap="round"
          opacity="0.5"
        />
      </g>
    </svg>
  );
}
